import React, { useState, useEffect } from 'react';
import { useAuth } from "./use-firebase.js";
import { useNavigate } from 'react-router-dom';
import Logo from "./components/common/Logo.js"
import { Row, Col, Card, Image, Button } from "react-bootstrap";

export default function Login(props) {

  const auth = useAuth();
  const navigate = useNavigate()
  const [error, setError] = useState(null)

  useEffect(() => {
    if (auth.user) {
      navigate('/dashboard');
    }
    window.scrollTo(0,0)
  }, [auth]);

  return (
    <Row style={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop: 60, marginBottom: 40, height: '100vh' }}>
      <Col xs={12} sm={12} md={8} lg={6} xl={5} style={{ textAlign: 'center' }}>
        <Button style={{ paddingTop: 10, paddingBottom: 10 }} onClick={() => auth.googleAuthenticate()}><Image src="/assets/logos/google.png" style={{ width: 24, marginRight: 10 }} />Continue with Google</Button>
        <p className="small" style={{ marginTop: 10 }}>No account yet?&nbsp;&nbsp;<a href="/signup">Create account</a></p>
      </Col>
    </Row>
  );
}
